'use strict';
import angular from 'angular';

angular.module('design.widget.filters', [])